import systemPropTypes from '@styled-system/prop-types';
import { themeGet } from '@styled-system/theme-get';
import PropTypes from 'prop-types';
import * as styledSystem from 'styled-system';
import theme from './theme';
const {
  get: getKey,
  compose,
  system
} = styledSystem;
export const get = key => themeGet(key, getKey(theme, key)); // Common props

export const COMMON = compose(styledSystem.space, styledSystem.color, styledSystem.display);
COMMON.propTypes = {
  ...systemPropTypes.space,
  ...systemPropTypes.color
}; // Typography props

const whiteSpace = system({
  whiteSpace: {
    property: 'whiteSpace' // cssProperty: 'whiteSpace',
  }
});

export const TYPOGRAPHY = compose(styledSystem.typography, whiteSpace);
TYPOGRAPHY.propTypes = {
  ...systemPropTypes.typography,
  whiteSpace: PropTypes.oneOf(['normal', 'nowrap', 'pre-wrap', 'pre', 'pre-line'])
}; // Border props

export const BORDER = compose(styledSystem.border, styledSystem.shadow);
BORDER.propTypes = {
  ...systemPropTypes.border,
  ...systemPropTypes.shadow
}; // Layout props

export const LAYOUT = styledSystem.layout;
LAYOUT.propTypes = systemPropTypes.layout; // Position props

export const POSITION = styledSystem.position;
POSITION.propTypes = systemPropTypes.position; // Flex props

export const FLEX = styledSystem.flexbox;
FLEX.propTypes = systemPropTypes.flexbox; // Grid props

export const GRID = styledSystem.grid;
GRID.propTypes = systemPropTypes.grid;